import React, { useEffect } from "react";
import { useGetDesigns } from "../api/get-designs";
import { useLocation, useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { transformDataForTrayModal } from "utils/transformdata";
import "features/Category/categoryProd/components/product.css";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { useGlobalContext } from "context/GlobalContext";
import InfoModal from "components/ui/InfoModal/InfoModal";
import Product from "./Product";
import SortContext from "context/SortContext";
import apiClient from "lib/api-client";
import { useDispatch } from "react-redux";
import { clearEditCategory } from "store/cartSlice";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const SetDesings = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { selectedSortValue, sortOptions, search, setSearch } = React.useContext(SortContext);
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const { data, error, isLoading } = useGetDesigns({ setID: id, sortBy: selectedSortBY, sortOrder: selectedSortOrder, searchTerm: search });
  const { infoModalOpen, setInfoModalOpen, setSetDesings, setDisplayCount, setSearchResultCount } = useGlobalContext();
  const fetchData = () => apiClient.get(`/api/v1/set/getSetWeightInfo/${id}`);


  // console.log(location.state);
  useEffect(() => {
    return () => {
      setSetDesings([]);
      setSearch("");
      dispatch(clearEditCategory("removedDesignsBySet"));
    };
  }, []);

  useEffect(() => {
    setSearchResultCount(data?.designs?.length);
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (isLoading) return <ProductSkeleton count={12} />;

  setSetDesings(data);

  const hasNoResults =
    search &&
    !data?.designs?.length;

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "32px",
          rowGap: "32px",
        }}
      >
        {data &&
          data?.designs?.map((design) => {
            const transformedProduct = transformDataForTrayModal(design);
            return <Product data={transformedProduct} allData={data?.designs} />;
          })}
      </Grid>
      <InfoModal open={infoModalOpen} setOpen={setInfoModalOpen} setDetails={true} fetchData={fetchData} title="Metadata Details" />
    </>
  );
};

export default SetDesings;
